import { defaultConfig, defineKeyframes } from '@chakra-ui/react';

const keyframes = defineKeyframes({
    ...defaultConfig.theme?.keyframes,
    scroll: {
        '0%': { transform: 'translateX(0)' },
        '100%': { transform: 'translateX(-50%)' },
    },
});

export { keyframes };
